<script setup lang="ts">
import { useEditor } from '@/composables/useEditor';

import Modal from './Modal.vue';
import WidgetEditor from './WidgetEditor.vue';

const emits = defineEmits(['config', 'close']);

const { overrideMainActionButton } = useEditor();
const editorService = useEditor();

function sendConfig() {
  emits('config', editorService.generateConfig());
}

function close() {
  emits('close');
}
</script>

<template>
  <Modal width="70vw" @close="() => close()">
    <template #title>
      {{ $t('editor.title') }}
    </template>
    <WidgetEditor />
    <template #footer>
      <div class="spacer">
        <span
          role="button" tabindex="0" class="delete-action" @click="editorService.clear"
          @keydown.enter="editorService.clear"
        >{{ $t('editor.delete_all')
        }}</span>
        <button
          v-if="overrideMainActionButton" type="button" class="main-action"
          @click="overrideMainActionButton.action"
        >
          {{ overrideMainActionButton.text }}
        </button>
        <button type="button" class="main-action" @click="sendConfig">
          {{ $t('editor.create_widget') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<style scoped>
.delete-action {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: lightgrey;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  cursor: pointer;
  color: white;
  font-weight: 600;
}

.main-action {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--yb-color-primary);
  padding: 0.5rem 1rem;
  border-radius: 10px;
  cursor: pointer;
  color: white;
  font-weight: 600;
}
</style>
